var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "8px",
    viewBox: "0 0 15 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "down-arrow1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website_2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "example-5_desktop",
    transform: "translate(-1370.000000, -61.000000)",
    fill: "#6E6672",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1342.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "down-arrow",
    transform: "translate(28.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4626198,0.250938339 C13.8144774,-0.0836548848 14.3822587,-0.0836548848 14.7339465,0.250990974 C15.0886585,0.58851444 15.088729,1.13741247 14.7338912,1.47462375 L8.13566314,7.74910088 C7.9644322,7.91193015 7.73618558,8 7.50002746,8 C7.26386935,8 7.03562273,7.91193015 6.86439178,7.74910088 L0.266163736,1.47462375 C-0.0887304698,1.13714291 -0.0887304698,0.588203248 0.266219086,0.250885721 C0.618120132,-0.0835347293 1.18585961,-0.0836006732 1.5374351,0.250938339 L7.5,5.92 L13.4626198,0.250938339 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down_arrow.4ecd9f2be92be7dfc9e298866adf7b6d.svg";
export { ForwardRef as ReactComponent };